import Reveal from "@/components/Reveal";

export default function MaklumatSection() {
  return (
    <section
      id="maklumat-pelayanan"
      data-testid="maklumat-section"
      className="border-y border-[#E3EBF3] bg-[#F3F7FB] px-6 py-20 md:px-12 md:py-28"
    >
      <Reveal>
        <div className="mx-auto max-w-3xl rounded-3xl border border-[#E3EBF3] bg-white p-8 text-center shadow-[0_18px_44px_rgba(11,36,64,0.08)] md:p-14">
          <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-[#EFF6FC]">
            <svg
              viewBox="0 0 24 24"
              aria-hidden="true"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              className="h-6 w-6 text-[#1479BF]"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              />
            </svg>
          </span>
          <h2
            data-testid="maklumat-title"
            className="mt-6 font-display text-3xl font-semibold text-[#0B2440] md:text-4xl"
          >
            Maklumat Pelayanan
          </h2>
          <p
            data-testid="maklumat-text"
            className="mt-6 text-[15px] leading-relaxed text-slate-600 md:text-lg"
          >
            Kami PPID LLDIKTI Wilayah VII, berkomitmen untuk memberikan
            pelayanan informasi publik sesuai dengan ketentuan yang termaksud
            dalam Undang-Undang Nomor 14 Tahun 2008 tentang Keterbukaan
            Informasi Publik beserta Peraturan pendukung lainnya. Apabila
            tidak menepati janji ini, kami siap menerima sanksi sesuai
            perundang-undangan yang berlaku.
          </p>
        </div>
      </Reveal>
    </section>
  );
}
